/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'

export type PaginationParams = {
  page?: number,
  limit?: number
}

function usePaginationQueryParams (params: Record<string, unknown>): PaginationParams {
  return useMemo(() => {
    const r: PaginationParams = {}

    if (typeof params.page === 'string') {
      r.page = parseInt(params.page, 10)
    }
    if (typeof params.limit === 'string') {
      r.limit = parseInt(params.limit, 10)
    }
    return r
  }, [params])
}

export default usePaginationQueryParams
